export const identity = <T>(t: T): T => t;
export default identity;
